import React, { useRef, useEffect, ReactElement } from 'react';

import { Box } from 'Modules/ui3';

import { SlideBaseProps, SliderProps } from './types';
import './index.scss';


export const Slider = <SlidePropsType extends SlideBaseProps<SlidePropsType['data']>, >({
    glider, elementsViewCount = 1, overflowSizePx,
    disabled, slidesData, slideComponent: Slide,
    ...props
}: SliderProps<SlidePropsType>): ReactElement<SliderProps<SlidePropsType>> => {
    const gliderRef = useRef<HTMLDivElement>();

    useEffect(() => {
        glider.mount();
    }, [glider]);

    useEffect(() => {
        if (disabled)
            glider.disable();
        else
            glider.enable();
    }, [disabled, glider]);

    useEffect(() => {
        glider.go('=0');
    }, [glider, elementsViewCount, overflowSizePx]);

    useEffect(() => {
        glider.update();
    }, [glider, slidesData, elementsViewCount, overflowSizePx, disabled]);

    return (
        <Box
            ref={gliderRef}
            id={glider.selector.replace('#', '')}
            className='glide'
            overflow='hidden'
        >
            <Box
                className='glide__track'
                data-glide-el='track'
                overflow='visible'
                width={overflowSizePx && !disabled ? `calc(100% - ${overflowSizePx}px)` : '100%'}
            >
                <Box component='ul' className='glide__slides' overflow='visible'>
                    {slidesData.map((data, slideIndex) => (
                        <li key={`slide_${slideIndex}`} className='glide_slide'>
                            <Slide data={data} {...props} />
                        </li>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};
